export function compute(total, treatment) {
  const t = Number(total || 0);
  const gst = treatment === "standard" ? Math.round((t / 11) * 100) / 100 : 0;
  const net = Math.round((t - gst) * 100) / 100;
  return { gst, net };
}
